import { breakpoints } from 'styles';
import { Box } from 'components/common/box';
import { ProfileInfo, ProfileSummaryHeader } from '.';

import type { RequestUser } from 'shared-types';

interface RequestUserWithLimitedUserBoolean extends RequestUser {
  isLimitedUser?: boolean;
}

interface Props {
  isPreview?: boolean;
  isUserPage: boolean;
  targetUser: RequestUserWithLimitedUserBoolean;
}

const ProfileSummaryInfo = ({ isPreview, isUserPage, targetUser }: Props) => (
  <Box>
    <div className="inner">
      <div className="header">
        <ProfileSummaryHeader
          isPreview={isPreview}
          isUserPage={isUserPage}
          targetUser={targetUser}
          isLimitedView={targetUser.isLimitedUser}
        />
      </div>
      <div className="info">
        <ProfileInfo
          hideCustomAttributes={targetUser.isLimitedUser}
          isPreview={isPreview}
          isUserPage={isUserPage}
          targetUser={targetUser}
        />
      </div>

      <style jsx>{`
        .info {
          margin-top: 40px;
        }
        @media (min-width: ${breakpoints.medium}px) {
          .inner {
            padding: 10px;
          }
        }
      `}</style>
    </div>
  </Box>
);

export default ProfileSummaryInfo;
